import React from 'react'
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Typography } from "@mui/material";
import Colors from '../../Constant/Colors';


const Topbar = () => {
  return ( 
    <>
    <Box display="flex" justifyContent="space-between" p={2} backgroundColor={Colors.primary}>
      <Box display="flex" >
        <Typography variant='h4'  marginLeft='18px' color={"white"} style={{ fontVariant:'small-caps', fontWeight:'600', letterSpacing:1, textShadow:'1px 1px 5px #370898'}}  >
          IconicArt
        </Typography>
      </Box>
      {/* SEARCH BAR */}
      
      {/* ICONS */}
      {/* <Box display="flex"  >
        <IconButton>
            <LightModeOutlinedIcon style={{color:'white'}} />
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon style={{color:'white'}} />
        </IconButton>
        <IconButton  >
          <SettingsOutlinedIcon style={{color:'white'}}/>
        </IconButton>
        <IconButton>
          <PersonOutlinedIcon style={{color:'white'}}/>
        </IconButton>
      </Box> */}
      <Box
        display="flex"
        backgroundColor={Colors.white}
        borderRadius="25px"
      >
        <InputBase sx={{ ml: 2, flex: 1}} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon /> 
        </IconButton>
      </Box>
    </Box>
    </>
  )
}

export default Topbar
